import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Grid2 } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import { statisticsStyles } from "components/statistics/styles";
import React from "react";
import { ReviewUserChart, ReviewUserForm } from "./container";

class ReviewUser extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            (<Grid2 container direction={"column"} spacing={3}>
                <Grid2 size={12}>
                    <Accordion defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>Search</AccordionSummary>
                        <AccordionDetails>
                            <ReviewUserForm />
                        </AccordionDetails>
                    </Accordion>
                </Grid2>
                <Grid2 size={12}>
                    <ReviewUserChart />
                </Grid2>
            </Grid2>)
        );
    }
}

export default withStyles(statisticsStyles)(ReviewUser);
